export const POC_COLUMNS = [
  { header: 'POC ID', accessor: 'poc_id' },
  { header: 'POC Name', accessor: 'poc_name', type: 'text' },
  { header: 'Total Impressions', accessor: 'impressions', type: 'number' },
  { header: 'Average Engagement Rate', accessor: 'engagement_rate', type: 'percent' },
  { header: 'Total Engagements', accessor: 'post_engagement', type: 'number' },
  { header: 'Total Reach', accessor: 'reach', type: 'number' },
  { header: 'Ad Spends', accessor: 'ad_spend', type: 'currency' },
];

// Separate columns for POC Level Analysis tab
export const POC_LEVEL_ANALYSIS_COLUMNS = [
  { header: 'POC ID', accessor: 'poc_id' },
  { header: 'POC Name', accessor: 'poc_name', type: 'text' },
  { header: 'Total Reach', accessor: 'reach', type: 'number' },
  { header: 'Total Impressions', accessor: 'impressions', type: 'number' },
  { header: 'Total Engagements', accessor: 'post_engagement', type: 'number' },
  { header: 'Average Engagement Rate', accessor: 'engagement_rate', type: 'percent' },
  { header: 'Clicks', accessor: 'clicks', type: 'number' },
];

export const REGION_COLUMNS = [
  { header: 'Total Impressions', accessor: 'impressions', type: 'number' },
  { header: 'Average Engagement Rate', accessor: 'engagement_rate', type: 'percent' },
  { header: 'Total Engagements', accessor: 'post_engagement', type: 'number' },
  { header: 'Total Reach', accessor: 'reach', type: 'number' },
  { header: 'Ad Spends', accessor: 'ad_spend', type: 'currency' },
];

export const BRAND_COLUMNS = [
  { header: 'Total Impressions', accessor: 'impressions', type: 'number' },
  { header: 'Average Engagement Rate', accessor: 'engagement_rate', type: 'percent' },
  { header: 'Total Engagements', accessor: 'post_engagement', type: 'number' },
  { header: 'Total Reach', accessor: 'reach', type: 'number' },
  { header: 'Ad Spends', accessor: 'ad_spend', type: 'currency' },
];

export const CAMPAIGN_COLUMNS = [
  { header: 'Total Impressions', accessor: 'impressions', type: 'number' },
  { header: 'Average Engagement Rate', accessor: 'engagement_rate', type: 'percent' },
  { header: 'Total Engagements', accessor: 'post_engagement', type: 'number' },
  { header: 'Total Reach', accessor: 'reach', type: 'number' },
  { header: 'Ad Spends', accessor: 'ad_spend', type: 'currency' },
];

export const PAALL_COLUMNS = [
  { header: 'POC Name', accessor: 'poc_name', type: 'text' },
  { header: 'POC ID', accessor: 'poc_id' },
  { header: 'Campaign', accessor: 'campaign_name' },
  { header: 'Total Impressions', accessor: 'impressions', type: 'number' },
  { header: 'Average Engagement Rate', accessor: 'engagement_rate', type: 'percent' },
  { header: 'Total Engagements', accessor: 'post_engagement', type: 'number' },
  { header: 'CPM', accessor: 'cpm', type: 'currency' },
  { header: 'Total Reach', accessor: 'reach', type: 'number' },
  { header: 'Clicks', accessor: 'clicks', type: 'number' },
  { header: 'Ad Spends', accessor: 'ad_spend', type: 'currency' },
];

export const ROI_COLUMNS = [
  { header: "Campaign Name", accessor: "campaign_name" },
  { header: "Total_Actuals (hL)", accessor: "total_actuals", type: "number" },
  { header: "Total_Forecasts (hL)", accessor: "total_forecasts", type: "number" },
  { header: "Uplift", accessor: "uplift", type: "number" },
  { header: "Region", accessor: "region" },
  { header: "BRAND", accessor: "brand" },
  { header: "Digital_Uplift%", accessor: "digital_uplift_percent", type: "percent" },
  { header: "MACO/HL", accessor: "maco", type: "currency" },
  { header: "Revenue", accessor: "revenue", type: "currency" },
  { header: "ROI%", accessor: "roi_percent", type: "percent" }
];

export const BENCHMARK_COLUMNS = [
  { header: "POC ID", accessor: "poc_id" },
  { header: "POC Name", accessor: "poc_name", type: "text" },
  { header: "Campaign Name", accessor: "campaign_name" },
  { header: "Brand", accessor: "brand" },
  { header: "Region", accessor: "region" },
  { header: "Total Impressions", accessor: "impressions", type: "number" },
  { header: "Total Reach", accessor: "reach", type: "number" },
  { header: "Total Engagements", accessor: "post_engagement", type: "number" },
  { header: "Average Engagement Rate", accessor: "engagement_rate", type: "percent" },
  { header: "Clicks", accessor: "clicks", type: "number" },
  { header: "CPM", accessor: "cpm", type: "currency" },
  { header: "Avg Deviation", accessor: "avg_deviation", type: "percent" },
  { header: "Poor Metrics", accessor: "poor_metric_count", type: "number" }
]; 